import { classNames } from '@op/opds.opux';
import type { HTMLAttributes } from 'react';
import styles from './PageHeading.module.scss';
import { useAutofocus, useTitle } from '../../../hooks';

interface Props extends HTMLAttributes<HTMLHeadingElement> {
  headingElement?: 'h1' | 'h2';
  title: string;
  className?: string;
}
const PageHeading = ({
  headingElement = 'h1',
  className,
  title,
  ...rest
}: Props) => {
  const headingRef = useAutofocus<HTMLHeadingElement>();
  useTitle(title);
  const Element = headingElement;
  return (
    <Element
      ref={headingRef}
      tabIndex={-1}
      className={classNames(styles.heading, className)}
      {...rest}>
      {title}
    </Element>
  );
};

export default PageHeading;
